
export default {


    price(currency, price) {
        const isCustomCurrency = currency && currency.code && currency.code.length > 3;
        const pricePrefix = currency && currency.symbol && !isCustomCurrency ? currency.symbol + ' ' : '';
        const priceSuffix = currency && currency.symbol && isCustomCurrency ? ' ' + currency.symbol : '';
        const currencyExponent = currency && currency.exponent !== undefined && currency.exponent !== null ? currency.exponent : 2;
        if(price) {
            return pricePrefix +
                price
                    .toFixed(currencyExponent) // always two decimal digits
                    .replace(".", ",") // replace decimal point character with ,
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") +
                priceSuffix;
        }
        return '-';
    },


    // lineItemsAsCartItems(lineItems) {
    //
    // },


}
